module.exports = __webpack_public_path__ + "static/img/7areaA_09.df5cadd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/7areaA_09.png
// module id = 913
// module chunks = 1